<template>
  <div class="number-range-input" :class="{ 'number-range-focused': wrapperFocused }">
    <el-input-number
        v-model="startValue"
        :placeholder="startPlaceholder"
        :disabled="disabled"
        :clearable="clearable"
        :controls="false"
        class="range-input"
        ref="input1"
        @change="handleStartChange"
        @focus="handleFocus(1)"
        @blur="handleBlur(1)"
    ></el-input-number>
    <span class="separator">{{ separator }}</span>
    <el-input-number
        v-model="endValue"
        :placeholder="endPlaceholder"
        :disabled="disabled"
        :clearable="clearable"
        :controls="false"
        class="range-input"
        ref="input2"
        @change="handleEndChange"
        @focus="handleFocus(2)"
        @blur="handleBlur(2)"
    ></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'NumberRangeInput',
  props: {
    // 双向绑定的值，格式为 [start, end]
    value: {
      type: Array,
      default: () => [undefined, undefined]
    },
    // 分隔符
    separator: {
      type: String,
      default: '至'
    },
    // 开始输入框的占位符
    startPlaceholder: {
      type: String,
      default: '最小值'
    },
    // 结束输入框的占位符
    endPlaceholder: {
      type: String,
      default: '最大值'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 尺寸
    size: {
      type: String,
      default: 'mini'
    },
    // 是否可清空
    clearable: {
      type: Boolean,
      default: true
    },
    // 最小值限制
    min: {
      type: Number,
      default: undefined
    },
    // 最大值限制
    max: {
      type: Number,
      default: undefined
    },
    // 是否自动交换大小值（当开始值大于结束值时自动交换）
    autoSwap: {
      type: Boolean,
      default: true
    },
    // 精度（小数位数），为0时只能输入整数
    precision: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      startValue: this.value[0],
      endValue: this.value[1],
      wrapperFocused: false,
      focusedInputs: []
    }
  },

  watch: {
    value: {
      handler (newVal) {
        this.startValue = newVal[0]
        this.endValue = newVal[1]
      },
      deep: true
    }
  },
  methods: {
    handleFocus (inputNumber) {
      this.focusedInputs.push(inputNumber)
      this.$nextTick(() => {
        this.checkIfAnyInputFocused()
      })
    },
    handleBlur (inputNumber) {
      // 使用setTimeout确保在下一个事件循环中检查焦点状态
      setTimeout(() => {
        let focusedInputs = this.focusedInputs.filter(item => item !== inputNumber)
        this.focusedInputs = focusedInputs
        this.$nextTick(() => {
          this.checkIfAnyInputFocused()
        })
      }, 10)
    },
    // 检查是否有任何输入框处于焦点状态
    checkIfAnyInputFocused () {
      if (this.focusedInputs.length === 0) {
        this.wrapperFocused = false
      } else {
        this.wrapperFocused = true
      }
    },
    handleStartChange (value) {
      this.startValue = value
      this.emitValue()
    },
    handleEndChange (value) {
      this.endValue = value
      this.emitValue()
    },
    emitValue () {
      let start = this.startValue
      let end = this.endValue

      // 自动交换逻辑
      if (this.autoSwap && start !== null && end !== null && start > end) {
        [start, end] = [end, start]
        this.startValue = start
        this.endValue = end
      }

      const result = [start, end]
      this.$emit('input', result)
      this.$emit('change', result)
    }
  }
}
</script>

<style lang="scss" scoped>
.number-range-input {
  display: flex;
  align-items: center;

  border-radius: 4px;
  border: 1px solid #DCDFE6;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

  .range-input {
    flex: 1;
    ::v-deep .el-input__inner {
      border: none;
    }
  }

  .separator {
    font-size: 12px;
    padding: 0 8px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #343434;
    letter-spacing: 1px;
  }
}
.number-range-input:hover {
  border-color: #C0C4CC;
}
/* 聚焦状态 */
.number-range-input.number-range-focused {
  border-color: #409eff !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-number-range-input/index.vue"
}
</vue-filename-injector>
